import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import css from './style.scss';


const DetailsCustomTab = (props) => {
    const { kind, className } = props;
    const tabsClass = classNames(css.tabs, css[kind], className);
    return <div {...props} className={tabsClass} />;
}

DetailsCustomTab.defaultProps = {
  kind: 'default',
};

DetailsCustomTab.propTypes = {
  kind: PropTypes.oneOf(['default', 'line']),
  className: PropTypes.string,
};


export default DetailsCustomTab;
